import React from "react";
import PropTypes from "prop-types";

import styles from "./StyleButton.css";
import classNames from "classnames";

import IconButton from "components/library/IconButton";

export default class StyleButton extends React.Component {
  constructor(props) {
    super(props);

    this.handleMouseDown = this._handleMouseDown.bind(this);
  }

  _handleMouseDown(e) {
    e.preventDefault();
    this.props.onToggle(this.props.style);
  }

  render() {
    const className = classNames(styles.root, this.props.className, {
      [styles.active]: this.props.isActive,
      [styles.disabled]: this.props.isDisabled,
    });

    return (
      <IconButton
        className={className}
        componentRef={this.props.componentRef}
        description={this.props.label}
        disabled={this.props.isDisabled}
        name={this.props.icon}
        onMouseDown={this.handleMouseDown}
      />
    );
  }
}

StyleButton.propTypes = {
  style: PropTypes.string.isRequired,
  onToggle: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool,
  icon: PropTypes.string.isRequired,
  label: PropTypes.string,
  iconClassName: PropTypes.string,
  className: PropTypes.string,
};
